module.exports = __webpack_public_path__ + "img/tee.6b97c89a.svg";